import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { HTAttachment, HTDocLookup, HTRequest } from "../../api/entities";
import { loadDocsLookUp } from "../../api/api";
import { HTDocType, HTLookUps } from "../../api/constants";
import { getDocName, mapLookupWithAttachments } from "../../Utils";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { DateUtil } from "@eres/core";

interface Props {
	request: HTRequest;
}

interface State {
	isLoading: boolean;
	documents: HTDocLookup[];
}

class RejectionInfo extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			documents: [],
		};
	}

	componentDidMount() {
		this.loadDocuments();
	}

	render() {
		const { request } = this.props;
		const { documents } = this.state;
		return <>
			<div className="section-title">
				<h5>{ Strings.rejection_details }</h5>
			</div>
			<div className="flex-grid flex-full">
				<div>
					<span>{ Strings.reason_for_rejection }</span>
					<span>{ request.RejectReason }</span>
				</div>
				<RenderDocs documents={ documents }/>
			</div>
		</>;
	}

	private loadDocuments() {
		loadDocsLookUp( HTLookUps.ATTACHMENTS, HTDocType.REJECT ).then( docs => {
			const { request } = this.props;
			const documents = docs || [];
			const state: Partial<State> = {
				documents: documents,
			};
			if ( request && request.RejectReasonDocuments && request.RejectReasonDocuments.length > 0 ) {
				mapLookupWithAttachments( documents, request.RejectReasonDocuments );
			}
			this.setState( {
				...state,
				isLoading: false,
			} as State );
		} );
	}
}

export function RenderDocs( props: { documents?: HTDocLookup[] } ) {
	const { documents } = props;
	if ( documents && documents.length > 0 ) {
		return <>
			{ documents.map( ( doc: HTDocLookup ) => {
				const lookupName = getLocalValue( doc );
				if ( doc.docs && doc.docs.length > 0 ) {
					return <div key={ `${ doc.Identity }` }>
						<span>{ lookupName }</span>
						<span>
                            { doc.docs?.map( ( attachment: HTAttachment, index: number ) => {
	                            if ( attachment.FileUrl && !isEmptyStringOrNull( attachment.FileUrl ) ) {
		                            const docName = getDocName( doc, attachment )?.replace( "~", "" + ( index + 1 ) );
		                            let date = undefined;
		                            if ( attachment.UploadDate && !isEmptyStringOrNull( attachment.UploadDate ) ) {
			                            date = DateUtil.formatDate( attachment.UploadDate?.asDate(), "DD/MM/YYYY hh:mm A", "en" );
		                            }
		                            return <React.Fragment key={ docName }>
                                        <span className="attach-doc-span">
                                        <a
	                                        href="#" className="underline d-flex"
	                                        onClick={ e => {
		                                        e.preventDefault();
		                                        window.open( attachment.FileUrl );
	                                        } }>{ docName }</a>
	                                        { date && <span dir={ "ltr" }>{ date }</span> }</span>
		                            </React.Fragment>;
	                            }
	                            return null;
                            } ) }
                        </span>
					</div>;
				}
				return null;
			} )
			}
		</>;
	}
	return null;
}

export default RejectionInfo;
